import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import banderoleImage from '../Images/Banderole.png';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Faire disparaître le message d’erreur après 3 secondes
  useEffect(() => {
    if (!error) return;

    const timer = setTimeout(() => {
      setError('');
    }, 3000);

    return () => clearTimeout(timer);
  }, [error]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    const auth = getAuth();

    try {
      setError('');
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/mapage/mes-infos');
    } catch (err: any) {
      switch (err.code) {
        case 'auth/invalid-email':
          setError('Adresse email invalide');
          break;
        case 'auth/user-not-found':
          setError('Aucun compte ne correspond à cette adresse email');
          break;
        case 'auth/wrong-password':
          setError('Mot de passe incorrect');
          break;
        default:
          setError('Une erreur est survenue lors de la connexion');
      }
      console.error('Erreur de connexion :', err);
    }
  };

  return (
    <div className="layout-container">
      <nav className="horizontal-menu">
        <ul className="horizontal-menu-list">
          <li>
            <Link
              to="/"
              className={`horizontal-menu-item ${location.pathname === '/' ? 'active' : ''}`}
            >
              Accueil
            </Link>
          </li>
          <li>
            <Link
              to="/actualites"
              className={`horizontal-menu-item ${location.pathname === '/actualites' ? 'active' : ''}`}
            >
              Actualités
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              className={`horizontal-menu-item ${location.pathname === '/contact' ? 'active' : ''}`}
            >
              Contact
            </Link>
          </li>
        </ul>
      </nav>

      <div className="layout-content">
        <header
          className="banderole"
          style={{ '--banderole-url': `url(${banderoleImage})` } as React.CSSProperties}
        >
          <div className="login-container">
            <form className="login-form" onSubmit={handleLogin}>
              <input
                type="email"
                placeholder="Email"
                className="input-field"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (error) setError('');
                }}
                required
              />

              <input
                type="password"
                placeholder="Mot de passe"
                className="input-field"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (error) setError('');
                }}
                required
              />

              <button type="submit" className="connexion-btn">
                Connexion
              </button>

              <Link to="/reset-password" className="forgot-password-link">
                Mot de passe oublié ?
              </Link>

              {error && <div className="error-message">{error}</div>}
            </form>
          </div>
        </header>

        <main className="page-content">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
